import React, { Component } from 'react';
import MenuIcon from '../images/menu-icon.svg';
import { joinClasses } from './utils/react_helper';

export default class SiteNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
    document.addEventListener('touchstart', this.handleClickOutside);
  }

  render() {
    if (this.props.hide) {
      return null;
    }
    return (
      <div className={this.wrapperClasses}>
        <button className="site-nav__button" onClick={this.onButtonClick}>
          <img className="site-nav__button-icon" src={MenuIcon} />
        </button>
        <nav className={this.listClasses}>
          <ol className="site-nav__list-inner">{this.props.links.map(this.renderLink)}</ol>
        </nav>
      </div>
    );
  }

  renderLink = (link, i) => {
    if (link.enable === false) {
      return;
    }

    if (link.separator) {
      return <li className="site-nav__separator" key={i}></li>;
    }

    return (
      <li key={i}>
        <a {...this.linkProps(link, i)}>{link.title}</a>
      </li>
    );
  };

  classNames = (link) => {
    const active = `${link.active ? 'nav-link--active' : ''}`;
    const className = `${link.class ? link.class : ''}`;

    return `nav-link ${active} ${className}`;
  };

  linkProps = (link) => {
    let linkProps = {
      className: this.classNames(link),
    };

    if (link.href) {
      linkProps.href = link.href;
    }

    for (let data in link.data) {
      linkProps[`data-${data}`] = link.data[data];
    }

    return linkProps;
  };

  handleClickOutside = (event) => {
    if (this.state.open) {
      const clickOnButton = event.target.closest('.site-nav__button') !== null;
      const clickOutsideContainer = event.target.closest('.site-nav__list') === null;
      if (!clickOnButton && clickOutsideContainer) {
        this.toggleMenu();
      }
    }
  };

  onButtonClick = (event) => {
    this.toggleMenu();
  };

  toggleMenu = () => {
    this.setState({ open: !this.state.open });
  };

  get wrapperClasses() {
    return ['site-nav', this.props.animated ? 'animated' : ''].join(' ');
  }

  get listClasses() {
    return joinClasses([
      'site-nav__list',
      this.state.open ? 'site-nav__list--open' : '',
      this.props.homesHidden ? 'site-nav__list--reduced-right' : '',
      this.props.ownerCTADisabled ? 'site-nav__list--no-owner-cta' : '',
    ]);
  }
}
